import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=62df6f64"
import script from "./UserTag.vue?vue&type=script&lang=js"
export * from "./UserTag.vue?vue&type=script&lang=js"
import style0 from "./UserTag.vue?vue&type=style&index=0&id=62df6f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports